import React from 'react';
import dayjs from 'dayjs';

const ReserveCardGuest = ({
  reserveData,
  alertFlag,
  linkArea,
}) => {
  return (
    <div className="flex w-full flex-col rounded-md border border-line bg-white sm:min-w-[400px]">
    {/* 予約番号 */}
    <div className="h-18 flex flex-row justify-center rounded-t bg-contents py-3 text-white minsm:h-12 minsm:items-center minsm:py-0 sm:h-auto sm:justify-start">
      <p className="text-sm whitespace-nowrap sm:pl-10">
        予約番号
      </p>
        <p className="mx-2 text-[20px] sm:mx-0 sm:ml-12 lg:ml-32 sm:py-3 sm:text-[32px]">
          {reserveData?.reservationNumber}
        </p>
      </div>
      <div className="text-sm flex w-full flex-col items-start px-3 font-medium text-navy sm:px-8 lg:flex-row lg:justify-between lg:px-10">
        {/* 予約詳細 */}
        <div className="flex w-full flex-col justify-center">
          {/* 予約日時 */}
          <div className="mt-6 flex flex-col lg:flex-row justify-start gap-x-8">
            <p className="w-32 min-w-32">予約日時</p>
            <div className="mt-1 lg:mt-0 lg:ml-8">
              {reserveData?.date && (
                <p className="whitespace-nowrap">
                  {`${dayjs(reserveData.date).format('YYYY')}年${dayjs(
                    reserveData.date
                  ).format('M')}月${dayjs(reserveData.date).format(
                    'D'
                  )}日(${dayjs(reserveData.date).format('dd')})${reserveData?.time ? ' ' + reserveData.time : ''}`}
                </p>
              )}
              {alertFlag === '1' && (
                <p className="text-sm mt-1 text-navy-light whitespace-nowrap">
                  ※予約日を過ぎています
                </p>
              )}
            </div>
          </div>
          {/* 予約店舗 */}
          <div className="mt-5 flex flex-col lg:flex-row justify-start gap-x-8 sm:mt-6 lg:mt-5">
            <p className="w-32 min-w-32">予約店舗</p>
            <p className="mt-1 lg:mt-0 lg:ml-8">{reserveData?.shopName}</p>
          </div>
          {/* 予約車両 */}
          <div className="mt-5 flex flex-col lg:flex-row justify-start gap-x-8 sm:mt-6 lg:mt-5">
            <p className="w-32 min-w-32 whitespace-nowrap">予約車両</p>
            <div className="flex flex-col mt-1 lg:mt-0 lg:ml-8">
              {(reserveData?.carInfo?.manufacturer ||
                reserveData?.carInfo?.carModel) && (
                <p
                  className={
                    [
                      reserveData?.carInfo?.manufacturer,
                      reserveData?.carInfo?.carModel,
                    ].join(' ').length > 20
                      ? 'break-all whitespace-pre-wrap'
                      : 'whitespace-nowrap'
                  }
                >
                  {reserveData?.carInfo?.manufacturer}{' '}
                  {reserveData?.carInfo?.carModel}
                </p>
              )}
              {reserveData?.carInfo?.year && (
                <p>
                  年式：{reserveData.carInfo.year}年
                </p>
              )}
              {reserveData?.carInfo?.mileage && (
                <p
                  className={
                    String(reserveData.carInfo.mileage).length > 20
                      ? 'break-all whitespace-pre-wrap'
                      : 'whitespace-nowrap'
                  }
                >
                  走行距離：{reserveData.carInfo?.mileage}km
                </p>
              )}
            </div>
          </div>
          {/* メールアドレス */}
          <div className="mt-5 flex flex-col lg:flex-row justify-start gap-x-8 sm:mt-6 lg:mt-5">
            <p className="w-32 min-w-32 whitespace-nowrap">メールアドレス</p>
            <p
              className="mt-1 lg:mt-0 lg:ml-8 break-all whitespace-pre-wrap max-w-[300px] sm:max-w-[400px]"
            >
              {reserveData?.userInfo?.email}
            </p>
          </div>
          {/* お名前 */}
          <div className="mt-5 flex flex-col lg:flex-row justify-start gap-x-8 sm:mt-6 lg:mt-5">
            <p className="w-32 min-w-32">お名前</p>
            <p
              className="mt-1 lg:mt-0 lg:ml-8 break-all whitespace-pre-wrap max-w-[300px] sm:max-w-[400px]"
            >
              {reserveData?.userInfo?.name}
            </p>
          </div>
          {/* 電話番号 */}
          <div className="mt-5 mb-6 flex flex-col lg:flex-row justify-start gap-x-8 sm:mt-6 sm:mb-6 lg:mt-5">
            <p className="w-32 min-w-32">電話番号</p>
            <p className="mt-1 lg:mt-0 lg:ml-8">{reserveData?.userInfo?.phoneNumber}</p>
          </div>
        </div>
      </div>
      {!!linkArea && (
        <>
          <div className="w-full px-3 sm:px-8">
            <div className="border-t border-line mb-4 sm:mt-0 sm:mb-6"></div>
          </div>
          <div className="w-full flex px-3 sm:px-8 mb-4 sm:mb-6">{linkArea}</div>
        </>
      )}
    </div>
  );
};

export default ReserveCardGuest;
